<app-ngx-mat-table
  tableName="Surveys Table"
  description="Shows a table of all surveys and enables their manipulation."
  dataType="survey"
  sortActive="survey_id"
  [tableData]="tableData"
  [showActions]="showActions"
  (clickedButton)="clickedButton($event)"
  i18n-tableName
  i18n-description
></app-ngx-mat-table>
